<template>
  <section-collapseable
    default-expanded
    hide-initial-always
  >
    <template v-slot:expanded>
      <div class="flex flex-between flex-vertical-center">
        <p class="done_text">This lead is in your inbox, hit done to remove it.</p>

        <button-default @click="markDone">Done</button-default>
      </div>
    </template>
  </section-collapseable>
</template>

<script>
import {MODELS} from "../../../services/models";

export default {
  name: "LeadNotAddressed",
  computed: {
    record() {
      // If activeRecord is null then return necessary empty info
      return this.$store.state.activeRecord ? this.$store.state.activeRecord.record : {
        id: null,
      };
    }
  },
  methods: {
    markDone() {
      const addressedBy = {
        id: this.$store.getters.authUser.id,
        class_name: MODELS.User.class_name,
      };

      this.$api.records.setAddressed(this.record.id, {addressedBy: addressedBy}).then(() => {
        this.$buefy.toast.open({message: "This lead has been marked done", type: "is-success"});
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.done_text {
  margin-right: 10px;
  font-size: 1.125rem;
  color: $text-muted;
  line-height: 1.2;
  font-weight: bold;
}
</style>
